import { render, staticRenderFns } from "./FullVideoSwiper.vue?vue&type=template&id=00cff323&scoped=true&"
import script from "./FullVideoSwiper.vue?vue&type=script&lang=js&"
export * from "./FullVideoSwiper.vue?vue&type=script&lang=js&"
import style0 from "./FullVideoSwiper.vue?vue&type=style&index=0&id=00cff323&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cff323",
  null
  
)

export default component.exports